<template>
  <div class="flex flex-col items-start" :class="componentWidth">
    <p class="text-xs text-center text-red-700" v-show="error">
      {{ $t('frontoffice.cart.messages.invalidValue') }}
    </p>
    <div class="flex text-gray-700 dark:text-white text-center items-center">
      <button :disabled="counter <= options.min"
              class="rounded p-1 shadow-xs border border-transparent duration-300"
              :class="disabledClass(modelValue <= options.min)"
        @click="Decrement"
      >
        <MinusIcon class="w-3 h-3" aria-hidden="true" />
      </button>
      <label for="increment" class="flex items-center text-xs lg:text-sm">
        <input
          v-bind="{
            ...$attrs,
            onInput: ($event) => {
              emitValue($event.target.value);
            },
            onBlur: ($event) => {
              $emit('blur');
            },
            onChange: ($event) => {
              $emit('change');
            },
            onKeyUp: ($event) => {
              $emit('keyup');
            },
            onKeypress: ($event) => {
              checkNumericValue($event)
            },
            onClick: ($event) => {
              $event.target.select();
            },
          }"
          class="w-full text-center bg-transparent text-xs leading-none"
          id="increment"
          name="increment"
          type="text"
          v-model.trim="counter"
        />
      </label>
      <button
        :disabled="options.max !== null && counter >= options.max"
        class="rounded p-1 shadow-xs border border-transparent duration-300"
        :class="disabledClass(options.max ? modelValue >= options.max : false)"
        @click="Increment"
      >
        <PlusIcon class="w-3 h-3" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script>
import { MinusIcon, PlusIcon } from '@heroicons/vue/24/outline';

export default {
  components: {
    MinusIcon,
    PlusIcon,
  },
  props: ['value', 'appOptions', 'modelValue', 'componentWidth'],

  data() {
    return {
      counter: this.modelValue,
      defaults: {
        standard: 1,
        step: 1,
        min: 1,
        max: null,
      },
      error: null,
    };
  },

  computed: {
    options() {
      return {
        ...this.defaults,
        ...this.appOptions,
      };
    },
  },

  watch: {
    modelValue() {
      this.counter = this.modelValue;
    },
  },

  methods: {
    Increment() {
      this.error = null;
      this.counter += this.options.step;
      this.$emit('update:modelValue', this.counter);
    },
    Decrement() {
      this.error = null;
      this.counter -= this.options.step;
      this.$emit('update:modelValue', this.counter);
    },

    emitValue(val) {
      this.error = null;
      this.counter = Number(val);
      if (this.counter <= this.options.min) {
        this.counter = this.options.min;
        this.error = 'Valore non ammesso';
      }
      if (this.options.max !== null && this.counter > this.options.max) {
        this.counter = this.options.min;
        this.error = 'Valore non ammesso';
      }
      this.$emit('update:modelValue', this.counter);
    },
    disabledClass(isDisabled) {
      return isDisabled ? 'bg-gray-200 text-gray-400 cursor-not-allowed dark:bg-lh_light_gray dark:text-lh_gray'
        : 'hover:text-lh_red hover:border-lh_red dark:hover:border-lh_gold dark:hover:text-lh_gold';
    },

    checkNumericValue(event) {
      if (!/[0-9\s+]/.test(event.key)) {
        event.preventDefault();
      }
    },
  },
};
</script>
